module.exports = __webpack_public_path__ + "media/my_images/search/pr-fd92135a31d9081f812af1e42d0c51d0.svg";